// client/src/components/VerifyEmailPage.js
import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Container, Typography, Alert, CircularProgress, Button, Box } from '@mui/material';
import AppBarHeader from './AppBarHeader';
import axiosInstance from '../axiosInstance';

function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setMessage('No verification token found in the link.');
      return;
    }
    axiosInstance.post('/auth/verify-email', { token })
      .then(() => {
        setStatus('success');
        setMessage('Your email address has been verified. You can now log in.');
      })
      .catch((err) => {
        setStatus('error');
        setMessage(err.response?.data?.message || 'Verification failed. The link may have expired.');
      });
  }, [searchParams]);

  return (
    <div>
      <AppBarHeader />
      <Container maxWidth="sm" sx={{ mt: 8, textAlign: 'center' }}>
        <Typography variant="h5" gutterBottom>Email Verification</Typography>
        {status === 'loading' && <CircularProgress sx={{ mt: 4 }} />}
        {status === 'success' && (
          <>
            <Alert severity="success" sx={{ mt: 2 }}>{message}</Alert>
            <Box sx={{ mt: 3 }}>
              <Button component={Link} to="/login" variant="contained">Log In</Button>
            </Box>
          </>
        )}
        {status === 'error' && (
          <>
            <Alert severity="error" sx={{ mt: 2 }}>{message}</Alert>
            <Box sx={{ mt: 3 }}>
              <Button component={Link} to="/login" variant="outlined">Back to Login</Button>
            </Box>
          </>
        )}
      </Container>
    </div>
  );
}

export default VerifyEmailPage;
